import { Component, OnInit } from '@angular/core';
import { NgbDatepickerConfig, NgbDate, NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VproService } from './../../service/vpro/vpro.service';
import { Appointment } from '../../models/appointment';
import { Physician } from '../../models/physician';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { DashCred } from 'src/app/models/dash';
import swal from 'sweetalert2';
import { Location } from '@angular/common';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { DoctorCalendarComponent } from 'src/app/component/doctor-calendar/doctor-calendar.component';
import moment from 'moment';
import { environment } from 'src/environments/environment';
declare var $: any;
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-front-desk',
  templateUrl: './front-desk.component.html',
  styleUrls: ['./front-desk.component.css']
})
export class FrontDeskComponent implements OnInit {
  physician: any;
  pdata1 = [];
  phydata1 = [];
  pdata = [];
  phydata = [];
  appointment = new Appointment();
  physiciand = new Physician();
  // patientd = new PatientD();
  phyId: any;
  model1: any;
  model: any;
  patientd = [];
  aid: any;
  data1: any;
  data: any;
  submitted = false;
  message: any;
  apdate: any;
  aptime: any;
  doc_name: any;
  res: any;
  dcred = new DashCred();
  org_code: any;
  currentDate = Utils.maxDate;
  rescheduleAppointmentForm: UntypedFormGroup;
  appointmnt: any;
  AppointmentStatus = Utils.APPOINTMENT_STATUS;
  p_purl: string;
  online_checkin: any;
  isChecked: boolean = false;
  scheduleOptions: any;
  constructor(config: NgbDatepickerConfig, calendar: NgbCalendar, private route: ActivatedRoute, private service: VproService,
    private router: Router,
    private location: Location,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
  ) {

  }

  ngOnInit() {
    this.aid = this.route.snapshot.params['aid'];
    this.getAppointId();
    this.getOrgDet(localStorage.getItem("LogUsr"));
    $('#datetimepicker13').datetimepicker({
      inline: true,
      sideBySide: true
    });


    this.rescheduleAppointmentForm = this._formBuilder.group({
      drid: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: [null],
      onlinecheckin: [null],
      scheduleOptions: [null, [Validators.required]],
      startTime: [Utils.timesNow, Validators.required],
      endTime: [''],
      aptname: ['']
    });
  }
  signUpUser(e: any): void {

    this.scheduleOptions = e;
  }

  getOrgDet(usereid: string) {
    this.spinner.show();
    try {
      this.service.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.spinner.hide();
          this.org_code = res[0].org_code;
          this.getAllPhysicians();
          this.getAppointment(this.org_code)
        },
        (error) => {
          this.spinner.hide();
          console.log(error);
        }
      );
    } catch (excep) {
      this.spinner.hide();
      console.log(excep);
    }
  }

  getAppointment(org_code) {
    let data = {
      org_code: org_code,
      aid: this.aid
    };
    this.spinner.show();
    this.service.displayAppoint(data).subscribe(
      (appointment: any[]) => {
        console.log("appointment===========", appointment);
        this.online_checkin = appointment[0].online_checkin;
        if (this.online_checkin) {
          this.scheduleOptions = 1;
        }
        if (appointment[0].online_checkin == true) {
          this.rescheduleAppointmentForm.patchValue(
            {
              scheduleOptions: 'true'
            }
          )
        } else {
          this.rescheduleAppointmentForm.patchValue(
            {
              scheduleOptions: 'false'
            }
          )
        }
        this.spinner.hide();
        this.appointmnt = appointment;
        this.patchAppointmentForm(this.appointmnt[0]);
      },
      (error) => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }

  getAllPhysicians() {
    try {
      this.spinner.show();
      let searchFields = { org_code: this.org_code };
      this.service.fetchPhysicians(searchFields).subscribe((result: Physician[]) => {
        this.spinner.hide();
        this.physician = result['result'];
        this.physician = this.physician.map(p => {
          p.fullname = `${p.first_name} ${p.last_name}`;
          return p;
        });
        console.log(this.physician);
      },
        (error) => {
          this.spinner.hide();
          console.log(error);
        });
    }
    catch (e) {
      console.log(e);
    }
  }

  getAppointId() {
    this.spinner.show();
    this.service.getAppointID(this.aid).subscribe(data => {
      this.spinner.hide();
      this.patientd = data;
      this.p_purl = environment.content_base_url + "/" + data[0].ppurl;
      console.log("Get appointId", this.patientd);
    }, (error) => {
      this.spinner.hide();
      console.log(error);
    });
  }

  patchAppointmentForm(val) {
    this.rescheduleAppointmentForm.patchValue(
      {
        drid: val.u_id,
        aptname: val.aptname
      }
    )
    let startDate = val.apdate.split('-');
    this.rescheduleAppointmentForm.patchValue({
      startDate: { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }
    })
    if (val.enddate) {
      let endDate = val.enddate.split('-');
      this.rescheduleAppointmentForm.patchValue({
        endDate: { year: parseInt(endDate[0]), month: parseInt(endDate[1]), day: parseInt(endDate[2]) }
      })
    }
    let startTime = val.aptime.split(':');
    this.rescheduleAppointmentForm.patchValue({
      startTime: { hour: parseInt(startTime[0]), minute: parseInt(startTime[1]) }
    })

    if (val.endtime) {
      let endTime = val.endtime.split(':');
      this.rescheduleAppointmentForm.patchValue({
        endTime: { hour: parseInt(endTime[0]), minute: parseInt(endTime[1]) }
      })
    }
  }

  // dateTimeChangeEvent for edit/reschedule Appointment
  dateTimeChangeEvent() {
    let { startTime, startDate, endTime } = this.rescheduleAppointmentForm.value

    // Set or Validate End Time
    if (endTime) {
      this.validateEndTime();
    }
    else {
      this.rescheduleAppointmentForm.patchValue({
        endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
      })
    }

    // Validate Start Time
    let isInvalid = Utils.validateStartTime(startTime, startDate);
    if (isInvalid) {
      this.rescheduleAppointmentForm.controls['startTime'].setErrors({ 'invalidStartTime': isInvalid })
    }
    else {
      this.rescheduleAppointmentForm.controls['startTime'].setErrors(null)
    }

  }

  validateEndTime() {
    let { startTime, endTime } = this.rescheduleAppointmentForm.value;
    let isInvalid = Utils.validateEndTime(startTime, endTime);
    if (isInvalid) {
      this.rescheduleAppointmentForm.controls['endTime'].setErrors({ 'invalidEndTime': true })
    }
    else {
      this.rescheduleAppointmentForm.controls['endTime'].setErrors(null)
    }
  }

  /**function addSchedule for add the schedule */
  reScheduleAppointment(data2) {
    let { day: startDay, month: startMonth, year: startYear } = this.rescheduleAppointmentForm.value.startDate;
    let data = {
      // pid: this.patientd[0].pid,
      drid: this.rescheduleAppointmentForm.value.drid,
      // aptname: `Consultation : ${this.patientIdBasedData.first_name} ${this.patientIdBasedData.last_name}`,
      apdate: startYear + "-" + startMonth + "-" + startDay,
      aptime: this.rescheduleAppointmentForm.value.startTime.hour + ':' + this.rescheduleAppointmentForm.value.startTime.minute,
      uid: JSON.parse(localStorage.getItem("uid")),
      updatedat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day
    };

    if (this.appointmnt[0] && this.appointmnt[0].pid) {
      data['patid'] = this.appointmnt[0].pid
      data['aid'] = Number(this.aid)
      var y: number = +this.aid;

    }
    if (this.rescheduleAppointmentForm.value.endDate) {
      let { year, month, day } = this.rescheduleAppointmentForm.value.endDate;
      data['enddate'] = year + "-" + month + "-" + day;
    }
    if (this.rescheduleAppointmentForm.value.endTime) {
      let { hour, minute } = this.rescheduleAppointmentForm.value.endTime;
      data['endtime'] = `${hour}:${minute}`;
    }
    if (this.rescheduleAppointmentForm.value.aptname) data['aptname'] = this.rescheduleAppointmentForm.value.aptname;
    data['action'] = "reschedule"
    data['patname'] = this.patientd[0].patient_first_name
    data['request_type'] = "new"
    data['schedule_stat'] = "Scheduled"
    data['status'] = "Scheduled"
    data['type'] = "personal"
    let type = this.rescheduleAppointmentForm.value.scheduleOptions;
    if (type == "false") {
      data['onlinecheckin'] = false;
    }
    else {
      data['onlinecheckin'] = true;
    }
    //Call to updateAppointment()
    this.updateAppointment(data);
  }

  //Function to update Appointment- Reschedule/Soft delete
  updateAppointment(data) {
    this.spinner.show();
    this.service.editSchedule(data, this.aid).subscribe(
      (res: any) => {
        this.spinner.hide();
        console.log("res", res)
        this.showToast('success', res);
        setTimeout(() => {
          this.router.navigate(['/appointments/Checkin']);
        }, 1000)
      },
      err => {
        this.spinner.hide();
        console.log(err);
        let message = "Something wrong. Couldn't re-schedule appointment.";
        if (err && err.error && err.error.error) {
          this.showToast('error', err.error.error);
          return;
        }
        this.showToast('error', message);
      }
    );
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }
  /** Modified by saurabh */
  /* public saveScheduleAppointment(data2): void {
    let patientDate: any;
    if ($("#datetimepicker13").val() != "") {
      patientDate = $("#datetimepicker13").val().split('/');
    }
    let dateOfPatient = patientDate[2].split(" ")[0] +
      "-" +
      patientDate[0] +
      "-" +
      patientDate[1];
    try {
      const data = {
        drid: data2['model'],
        doc_name: data2['model']['fullname'],
        apdate: dateOfPatient,
        aptime: patientDate[2].split(" ")[1] + " " + patientDate[2].split(" ")[2]
      };
      swal.fire({
        title: 'Modify appointment',
        text: " Are you sure ?",
        type: 'info',
        showCancelButton: true,
        buttonsStyling: true,
        confirmButtonClass: 'btn btn-danger',
        confirmButtonText: 'Yes',
        cancelButtonClass: 'btn btn-secondary'
      }).then((result) => {
        if (result.value) {

          this.service.Reschedule(this.aid, data).subscribe(resp => {
            this.submitted = true;
            // if (confirm("You have successfully rescheduled the appointment")) {
            //   this.cancel();
            // }
          }, err => {
            console.log(err);
          });


          // Show confirmation
          swal.fire({
            title: 'Appointment Re-scheduled',
            text: 'Patient will be informed about it ',
            type: 'success',
            showConfirmButton: false,
            timer: 2000,

          });
          this.router.navigate(['/appointments/Checkin']);
        }
      })

    } catch (excep) {
      console.log(excep)
    }
  } */
  /** navigating to older components */
  private cancel(): void {
    this.router.navigate(['/appointments/Checkin']);
  }

  deleteAppoint(): void {
    swal.fire({
      title: 'Appointment cancellation',
      text: " Are you sure ?",
      type: 'info',
      showCancelButton: true,
      buttonsStyling: true,
      confirmButtonClass: 'btn btn-danger',
      confirmButtonText: 'Yes',
      cancelButtonClass: 'btn btn-secondary'
    }).then((result) => {
      if (result.value) {
        let data = { ...this.appointmnt[0] }
        //construct apdate
        let aptDate = this.appointmnt[0].apdate.split('-');
        aptDate = { year: parseInt(aptDate[0]), month: parseInt(aptDate[1]), day: parseInt(aptDate[2]) }
        let { year, month, day } = aptDate;
        data.apdate = `${year}-${month}-${day}`;
        data.status = this.AppointmentStatus.REJECTED;
        data.uid = JSON.parse(localStorage.getItem("uid"));
        data.drid = this.rescheduleAppointmentForm.value.drid;
        //call to updateAppointment()
        this.updateAppointment(data);
        this.router.navigate(['patient-list']);
      }
    })

  }

  getback() {
    this.location.back();
  }

  openCalendarMOdal() {
    const modalRef = this.modalService.open(DoctorCalendarComponent, { backdropClass: 'modal-backdrop', size: 'lg', centered: true, backdrop: 'static' });

    modalRef.componentInstance.drid = this.rescheduleAppointmentForm.value.drid;

    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patchDateAndTime(receivedEntry);
      modalRef.close();
    })

    modalRef.componentInstance.closeModal.subscribe((val) => {
      modalRef.dismiss();
    })

    modalRef.result.then(
      (result) => {
        console.log("result", result);
      },
      (reason) => {
        console.log("reason", reason);
      }
    );
  }

  patchDateAndTime(dateTime) {
    this.rescheduleAppointmentForm.patchValue({
      startDate: { year: parseInt(moment(dateTime).format('YYYY')), month: parseInt(moment(dateTime).format('MM')), day: parseInt(moment(dateTime).format('DD')) },
      startTime: { hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) },
    })
    this.dateTimeChangeEvent();
  }

}